<template>
  <!-- 经纪人列表 -->
  <div id="agentRole">
    <!-- 头部数据更新时间模块 -->
    <headerUpdate></headerUpdate>
    <b-card class="header-top" ref="headerH">
      <div class="header-page-title">
        <div class="title">
          {{ currentPageTitle }}
        </div>
      </div>
      <!-- 添加 -->
      <b-button class="add add-tab" variant="primary" @click="handleAdd">
        <!-- <svg class="icon icon-12 icon-search" aria-hidden="true">
            <use xlink:href="#icon-v4_7_h"></use>
          </svg> -->
        {{ $t("common.add") }}
      </b-button>
      <b-row>
        <b-col lg="9">
          <!--商户-->
          <b-form-group class="find-middle">
            <label v-if="!disabledBroker">
              {{ $t("common.clientName") }}
            </label>
            <v-select v-if="!disabledBroker" class="find-select" v-model="brokerId" :options="brokerList"
              :disabled="disabledBroker">
              <div slot="no-options">{{ $t("common.noFind") }}</div>
            </v-select>
            <!-- <div style="height: 64px" v-if="disabledBroker"></div> -->
          </b-form-group>
        </b-col>
        <b-col lg="3" class="header-right-btn" v-if="!disabledBroker">
          <div class="find-middle find-btnBox">
            <b-button variant="primary" @click="query">
              <!-- <svg class="icon icon-14 icon-search" aria-hidden="true">
                        <use xlink:href="#icon-v4_17"></use>
                      </svg> -->
              {{ $t("common.search") }}</b-button>
            <b-button variant="light" @click="reset">
              <!-- <svg class="icon icon-14 icon-reset" aria-hidden="true">
                        <use xlink:href="#icon-v4_3"></use>
                      </svg> -->
              {{ $t("common.reset") }}</b-button>
          </div>
        </b-col>
      </b-row>
      <!-- 头部分割线 -->
      <div class="header-top-bottom-bor"></div>
    </b-card>
    <b-card class="table-card">
      <div slot="header">
        <div class="table-title float-left">
          <!-- 数据总览 标题 -->
          <!-- {{ $t("lanV4.Datascreening") }} -->
          <span v-if="pages.total > 0">
            {{ $t("el.pagination.total", { total: pages.total }) }}
          </span>
        </div>
        <!-- 导出 -->
        <b-button v-if="false" class="float-right btn-export" variant="light"
          :class="!isexportIng ? 'lodingSattus' : ''" @click="exports">
          <svg class="icon icon-16" aria-hidden="true">
            <use xlink:href="#icon-v4_6_h"></use>
          </svg>
          {{ exportButtonText }}
          <svg v-if="!isexportIng" class="icon icon-20 btn-loading" aria-hidden="true">
            <use xlink:href="#icon-v4_loading"></use>
          </svg>
        </b-button>
      </div>
      <b-row>
        <b-col class="table-section">
          <el-table :height="$store.state.baseData.tableH" class="table-container" :data="tableList"
            @sort-change="sortChanged" :cell-class-name="addEnClass" :default-sort="{ prop: '', order: '' }">
            <template slot="empty">
              <load-skeleton v-show="loading" :columns="6" :rows="10" :haveLeftNumber="false"></load-skeleton>
              <h4 class="common-table-noData" v-show="!loading">
                <img src="../../assets/images/v4_nodata.png" alt="" />
                <div class="noData-text">
                  {{ $t("common.noData") }}
                </div>
              </h4>
            </template>

            <!--  序号 -->
            <el-table-column prop="sort" align="left" :label="$t('common.sort')" width="100">
            </el-table-column>

            <!-- 角色名称 -->
            <el-table-column prop="roleName" :label="$t('roleManagement.roleName')" align="right" width="150">
            </el-table-column>
            <!-- 所含经纪人数 -->
            <!--       :render-header="renderHeader"  -->
            <el-table-column align="right" :label="$t('lanV4.Brokersincluded')" sortable="'custom'" prop="agentNumber" width="200">
              <template slot-scope="scope">
                <div class="agent-number cursor-pointer" v-if="scope.row.agentNumber > 0"
                  @click="handleView(scope.row)">
                  {{ scope.row.agentNumber }}
                </div>
                <div v-else>
                  {{ scope.row.agentNumber }}
                </div>
              </template>
            </el-table-column>
            <!-- 分成方式 -->
            <el-table-column prop="roleTypeInfo" :label="$t('lanV4.Sharetype')" align="right" width="150">
            </el-table-column>
            <!-- 返佣比例 -->
            <el-table-column align="right" :label="$t('lanV4.Rebateratio')" prop="returnScaleMinMaxStr" width="150">
              <template slot-scope="scope">
                <div v-if="scope.row.roleType == 0 || scope.row.roleType == 2">
                  <!-- 比例经纪人和固定极差经纪人 -->
                  {{ scope.row.returnScaleMinMaxStr }}
                </div>
                <div v-else>
                  <!-- 极差经纪人 -->
                  {{ scope.row.returnScaleStr }}
                </div>
              </template>
            </el-table-column>

            <!-- 最高返佣等级 -->
            <el-table-column prop="maxLevel" :label="$t('lanV4.RebateratioLever')" align="right" width="200">
            </el-table-column>

            <!--  创建时间-->
            <el-table-column prop="ctime" align="right" :label="$t('lanV4.Creationtime')" width="200">
            </el-table-column>
            <!-- 操作 -->
            <el-table-column prop="action" :label="$t('common.find')" fixed="right" align="right" width="220">
              <template slot-scope="scope">
                <!-- 编辑 -->
                <b-button size="sm" variant="outline-primary" @click="handleEdit(scope.row)">
                  {{ $t("common.editor") }}
                </b-button>
                <!-- 删除 -->
                <el-popover placement="bottom" title="" width="300" manual-mode="scope.row.visible3">
                  <div class="content">
                    <!--你确定删除该角色吗？ -->
                    {{ $t("lanV4.deleteRole") }}
                  </div>
                  <el-button class="el-popover-btn-del" size="mini" type="text" @click="handlePopoverClose()">
                    {{ $t("common.cancel") }}
                  </el-button>
                  <el-button class="el-popover-btn-confirm" type="primary" size="mini" @click="handleDelete(scope.row)">
                    {{ $t("common.codeSuc") }}
                  </el-button>
                  <b-button size="sm" variant="outline-primary" slot="reference">
                    <!-- 删除 -->
                    {{ $t("lanV4.Delete") }}
                  </b-button>
                </el-popover>
              </template>
            </el-table-column>
          </el-table>
        </b-col>
      </b-row>
      <b-row class="mar-t-20">
        <b-col>
          <v-page v-if="pages.total > 0" :total-rows="pages.total" :perPage="pages.size" :pageOptions="pages.options"
            :currentPage="pages.page" @initialize="pageChange"></v-page>
        </b-col>
      </b-row>
    </b-card>

    <!-- 导出10000条提示 -->
    <b-modal v-model="exportsModalShow" :title="$t('exportsModal.text1')" size="md" centered scrollable
      no-close-on-backdrop id="code-modal">
      <div class="body-content">
        <div class="expor-number-tip">
          {{
            $t("exportsModal.text2", {
              pagesTotal: pages.total,
              maxNum: exportNumLimit,
            })
          }}
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button class="coustom-btn" variant="secondary" @click="onReset">{{
          $t("common.cancel")
          }}</b-button>
        <b-button class="coustom-btn" variant="primary" @click="exports('true')"
          :class="!isexportIng ? 'lodingSattus' : ''">
          <template v-if="!isexportIng">
            {{ $t("common.exportIng") }}
          </template>
          <template v-else>
            <!-- 继续导出 -->
            {{ $t("exportsModal.text3") }}
          </template>
        </b-button>
      </template>
    </b-modal>

    <agentRoleModal v-if="modalShow" :modalShow="modalShow" :modalType="modalType" :itemData="itemData"
      @changeModalShow="changeModalShow" @changeModalType="changeModalType" :brokerId="brokerId">
    </agentRoleModal>
  </div>
</template>
<script>
import commonMixin from "@/mixin/common/commonMixin";
import { fixD, fixInput, formatTime, multiply } from "@/apis/newmethods";
import headerUpdate from "./components/headerUpdate.vue";
import agentRoleModal from "./components/agentRoleModal.vue";
import {
  normalizeRoleOperationPermissions,
} from "./agentOperationPermissions";

export default {
  name: "agentRole",
  mixins: [commonMixin],
  components: {
    headerUpdate,
    agentRoleModal,
  },
  data() {
    return {
      brokerId: null, //商户id
      brokerList: [],

      pages: {
        page: 1, // 当前页数
        size: 10, // 页数大小
        options: [10, 40, 60, 100], // 页数大小选择
        total: 0, // 总页数
      },
      notData: true,
      loading: true,
      tableList: [],
      modalShow: false,
      isexportIng: true,
      sortBy: null, //预先排序的字段
      sortDesc: true, //预先降序
      sortName: "", //默认排序字段
      sortSet: 1, //默认倒序
      modalType: null,
      itemData: null, //弹窗回显数据
    };
  },
  computed: {
    exportButtonText() {
      if (!this.isexportIng) {
        return this.$t("common.exportIng"); // '正在导出'
      }
      return this.$t("common.export");
    },
  },
  watch: {
    pid(v) {
      if (v) {
        this.$nextTick(() => {
          this.pid = fixInput(v, 0, { num: 1 });
        });
      }
    },
    brokerId(v) {
      if (v) {
        this.pages.page = 1;
        this.getData();
      }
    },
  },
  created() {
    this.getBrokerList();
  },
  methods: {
    // 获取商户列表
    getBrokerList() {
      this.$http({
        url: this.$store.state.url.common.getBrokerList,
      }).then(({ data, code, msg }) => {
        if (data && code.toString() === "0") {
          let arr = [];
          // if (this.roleType === 1) {
          //   arr.push({ label: this.$t("common.all"), value: null });
          // }
          if (data.length) {
            data.map((item) => {
              arr.push({ label: item.brokerName, value: item.id });
            });
            this.brokerList = arr;
            this.brokerId = arr[0];
          }
        } else {
          this.$bus.$emit("alert", { type: "error", message: msg });
        }
      });
    },
    // 点击所含经纪人数跳转
    handleView(row) {
      const queryObj = {
        roleName: row.id, //id就是角色名称的value
      };
      this.$router.push({ path: "/agentList", query: queryObj });
    },
    // 删除弹窗关闭
    handlePopoverClose() {
      document.getElementById("agentRole").click();
    },
    // 添加
    handleAdd() {
      this.itemData = null;
      this.modalType = "Add";
      this.modalShow = true;
    },
    //编辑
    handleEdit(row) {
      this.modalType = "Edit";
      this.itemData = row;
      this.modalShow = true;
    },

    // 删除
    handleDelete(row) {
      if (row.agentNumber == 0) {
        this.$http({
          url: this.$store.state.url.agent.co_agent_role_set,
          params: {
            roleId: row.id,
            status: 0,
          },
        }).then(({ code, msg }) => {
          this.handlePopoverClose();
          if (code.toString() === "0") {
            this.$bus.$emit("alert", { type: "success", message: msg });
            this.getData();
          } else {
            this.$bus.$emit("alert", { type: "error", message: msg });
          }
        });
      } else {
        this.$bus.$emit("alert", {
          type: "error",
          message: this.$t("lanV4.deleteAgent"),
        });
      }
    },

    // 英文数字字体
    addEnClass({ row, column }) {
      switch (column.property) {
        case "uid":
          return "enNum";
        case "pid":
          return "enNum";
        case "tradeAmount":
          return "enNum";
        case "fee":
          return "enNum";
        case "returnAmount":
          return "enNum";
      }
    },

    // 箭头图标
    //   renderHeader (h, { column, $index }) {
    //    if (column.order === 'ascending') {
    //      return (
    //        <div>
    //          <span>{column.label}</span>
    //          {/* <i class="el-icon-sort-up"></i> */}
    //          <img src="https://s3.ap-northeast-1.amazonaws.com/chainup-test/agent_up.png"></img>
    //        </div>
    //      )
    //    } else if (column.order === 'descending') {
    //      return (
    //        <div>
    //          <span>{column.label}</span>
    //          {/* <i class="el-icon-sort-down"></i> */}
    //          <img src="https://s3.ap-northeast-1.amazonaws.com/chainup-test/agent_down.png"></img>
    //        </div>
    //      )
    //    } else {
    //      return (
    //        <div>
    //          <span>{column.label}</span>
    //          {/* <i class="el-icon-sort"></i> */}
    //          <img src="https://s3.ap-northeast-1.amazonaws.com/chainup-test/agent_de.png"></img>
    //        </div>
    //      )
    //    }
    //  },
    // 排序变化
    sortChanged(ctx) {
      switch (ctx.prop) {
        case "agentNumber":
          this.sortName = "agentNumber";
          break;
      }
      if (ctx.order === "descending") {
        this.sortSet = 1;
      } else if (ctx.order === "ascending") {
        this.sortSet = 0;
      } else {
        this.sortSet = null;
        this.sortName = null;
      }
      this.getData();
    },
    // 搜索
    query() {
      this.pages.page = 1;
      this.loading = true;
      this.getData();
    },
    // 重置
    reset() {
      this.brokerId = this.brokerList[0];
    },
    // 获取数据列表
    getData() {
      this.loading = true;
      this.tableList = [];
      const paramsData = {
        companyId: this.brokerId ? this.brokerId.value : null,
        pageNum: this.pages.page,
        pageSize: this.pages.size,
        sortName: this.sortName,
        sortSet: this.sortSet,
        isExport: 0,
      };
      this.$http({
        url: this.$store.state.url.agent.co_agent_role_list,
        params: paramsData,
        // method: "get",
        // apiType: "fe-json-server",
      })
        .then(({ data, code, msg }) => {
          this.loading = false;
          if (data && code.toString() === "0") {
            this.setData(data.pageInfo);
          } else {
            this.$bus.$emit("alert", { type: "error", message: msg });
          }
        })
        .catch((e) => {
          this.loading = false;
        });
    },
    setData(datas) {
      console.log(datas, 'datas')
      const { total, rows } = datas;
      this.pages.total = total ? total : 0;
      let arr = [];
      if (rows && rows.length) {
        rows.map((item, index) => {
          let minScale = item.scaleVos.length > 0 ? item.scaleVos[0].scale : 0;
          let maxScale = item.scaleVos.length > 0 ? item.scaleVos[0].scale : 0;
          let returnScaleMinMaxStr = null
          if (item.roleType == 0) {
            // 比例经纪人返佣比例
            for (const obj of item.scaleVos) {
              if (obj.scale < minScale) {
                minScale = obj.scale;
              }
              if (obj.scale > maxScale) {
                maxScale = obj.scale;
              }
            }
            returnScaleMinMaxStr = `${multiply(item.returnScaleMin, 100)}～${multiply(item.returnScaleMax, 100)}%`
          }
          //  固定极差返佣比例
          if (item.roleType == 2) {
            returnScaleMinMaxStr = `${multiply(item.returnScaleMin, 100)}～${multiply(item.returnScaleMax, 100)}%`
          }
          const operationPermissions = normalizeRoleOperationPermissions(item);
          arr.push({
            id: item.id,
            sort: (this.pages.page - 1) * this.pages.size + (index + 1), //序号
            roleName: item.name, //角色名称
            agentNumber: item.agentNumber, //所含经纪人数
            roleType: item.roleType, //分成方式
            roleTypeInfo: item.roleTypeInfo, //分成方式字符串
            maxLevel: this.roleType == 1 || this.roleType == 0 ? item.maxLevel : "--", //最高返佣等级
            ctime: item.ctime ? formatTime(item.ctime) : "--", //添加时间
            scaleVos: item.scaleVos,
            returnScale: item.returnScale, //极差经纪人返佣比例
            returnScaleStr: `${multiply(item.returnScale, 100)}%`, //极差经纪人返佣比例%
            returnScaleMinMaxStr: returnScaleMinMaxStr,////比例经纪人返佣比例区间%
            selfRebateStatus: item.selfRebateStatus, //自返佣开关
            permission: operationPermissions,
          });
        });
      }
      if (arr.length === 0) {
        this.notData = true;
      }
      this.tableList = arr;
    },
    // 导出
    exports(istrue) {
      if (
        istrue !== "true" &&
        this.pages.total &&
        Number(this.pages.total) > this.exportNumLimit
      ) {
        this.exportsModalShow = true;
      } else {
        if (!this.isexportIng) return;
        this.isexportIng = false;
        const paramsData = {
          companyId: this.brokerId ? this.brokerId.value : null,
          pageNum: this.pages.page,
          pageSize: this.exportNumLimit,
          sortName: this.sortName,
          sortSet: this.sortSet,
          isExport: 1,
        };

        this.outExcel(
          this.$store.state.url.agent.co_agent_role_list,
          paramsData,
          "increment-api"
        ).then((datas) => {
          if (datas.code === "0") {
            this.$bus.$emit("alert", {
              type: "success",
              message: this.$t("common.exportSuccess"),
            }); // 导出成功
            this.exportsModalShow = false;
            setTimeout(() => {
              this.isexportIng = true;
            }, 500);
          } else {
            this.$bus.$emit("alert", {
              type: "error",
              message: this.$t("common.exportError"),
            }); // 导出失败
          }
        });
      }
    },
    changeModalShow(data) {
      this.modalShow = data;
    },
    changeModalType(data) {
      this.modalType = data;
    },
    onReset() {
      this.exportsModalShow = false;
    },
    // 分页
    pageChange(data) {
      const { page, pageSize } = data;
      this.pages.page = page;
      this.pages.size = pageSize;
      const v = "page";
      this.getData(v);
    },
  },
};
</script>

<style lang="scss">
#agentRole {
  .el-table__fixed-right {
    background-color: #fff;
    z-index: 4;
  }

  @supports selector(::-webkit-scrollbar) {
    .el-table--scrollable-x .el-table__fixed-right {
      // 与 _common_v4.scss 中自定义横向滚动条的 8px 高度保持一致。
      height: calc(100% - 8px) !important;

      .el-table__fixed-body-wrapper {
        height: auto !important;
        bottom: 0;
      }
    }
  }

  .add-tab {
    position: absolute;
    top: 16px;
    right: 26px;
  }

  .custom-control {
    top: 5px !important;
  }

  .agent-number {
    color: #095be8;
    cursor: pointer;
  }
}
</style>
